import { render, staticRenderFns } from "./exam-view.vue?vue&type=template&id=a7417eda&scoped=true"
import script from "./exam-view.vue?vue&type=script&lang=ts"
export * from "./exam-view.vue?vue&type=script&lang=ts"
import style0 from "./exam-view.vue?vue&type=style&index=0&id=a7417eda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7417eda",
  null
  
)

export default component.exports